import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../config/api";

const roleLabels = {
  // attendance: "Attendance",
  cash: "Cash Wallet",
  fine: "Fine Wallet",
  watchman: "Watchman",
  ovisit: "Outdoor Visits",
  svisit: "Sales Visits",
  plating: "Plating",
  // leave_status: "Leave Module",
  task: "Task",
  reminder: "Reminder",
  // vpp: "VPP",
  // safe: "Safe Module",
  meter: "Meter Module",
  slead: "Sales Leads",
  check_in: "In-Out Products",
  sstock: "Sales Stock",
  // parcel: "Parcel",

  // check_out: "Check Out",
  bazar: "Bazar Work",
  // cateloge: "Forming Catalogue",
  // olead: "Order Leads",
  ostock: "Office Stock",
  rstock: "Row Stock",
  // bill: "Bill",
  report: "Report",
  // allorder: "All Orders",
  // neworder: "New Orders",
  // korder: "K Orders",
  // dorder: "D Orders",
  // deliverd: "Delivered",
  // cancelled: "Cancelled",
  customer: "Customer",
  // logs: "Logs",
  // gold: "Gold Catalogue", // extra from your earlier form
};
const EditStaff = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [staffData, setStaffData] = useState({
    name: "",
    number: "",
    email: "",
    password: "",
    inside_outside: "inside",
    reference_name: "",
    reference_number: "",
    address: "",
    ...Object.fromEntries(Object.keys(roleLabels).map((k) => [k, 0])),
  });

  const [fileData, setFileData] = useState({
    aadhaar_card_image: null,
    pan_card_image: null,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch staff info + roles
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // 1. Staff info
        const staffRes = await fetch(`${BASE_URL}staff/${id}`);
        const staffJson = await staffRes.json();

        if (staffJson.status === 1) {
          const staff = staffJson.data;
          setStaffData((prev) => ({
            ...prev,
            name: staff.name || "",
            number: staff.number || "",
            email: staff.email || "",
            password: staff.password || "",
            inside_outside: staff.inside_outside || "inside",
            reference_name: staff.reference_name || "",
            reference_number: staff.reference_number || "",
            address: staff.address || "",
          }));
        }

        // 2. Roles
        const roleRes = await fetch(`${BASE_URL}roles/${id}`);
        const roleJson = await roleRes.json();

        if (roleJson.data && roleJson.data.length > 0) {
          const roleObj = roleJson.data[0]; // only one record per staff
          const roles = Object.fromEntries(
            Object.keys(roleLabels).map((key) => [
              key,
              Number(roleObj[key]) || 0,
            ])
          );
          setStaffData((prev) => ({ ...prev, ...roles }));
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch staff or roles.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, type, files, checked, value } = e.target;
    if (type === "file") {
      setFileData((prev) => ({ ...prev, [name]: files[0] }));
    } else if (type === "checkbox") {
      setStaffData((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
    } else {
      setStaffData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Submit updates
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!staffData.name || !staffData.number || !staffData.email) {
      setError("Name, Number and Email are required.");
      return;
    }

    try {
      setLoading(true);

      // 1. Update staff info
      const staffForm = new FormData();
      staffForm.append("name", staffData.name);
      staffForm.append("number", staffData.number);
      staffForm.append("email", staffData.email);
      staffForm.append("password", staffData.password);
      staffForm.append("inside_outside", staffData.inside_outside);
      staffForm.append("reference_name", staffData.reference_name || "");
      staffForm.append("reference_number", staffData.reference_number || "");
      staffForm.append("address", staffData.address || "");

      if (fileData.aadhaar_card_image)
        staffForm.append("aadhaar_card_image", fileData.aadhaar_card_image);
      if (fileData.pan_card_image)
        staffForm.append("pan_card_image", fileData.pan_card_image);

      const staffRes = await fetch(`${BASE_URL}staff/${id}`, {
        method: "PUT",
        body: staffForm,
      });
      const staffResult = await staffRes.json();

      if (staffResult.status !== 1) {
        setError(staffResult.error || "Failed to update staff.");
        setLoading(false);
        return;
      }

      // 2. Update roles (POST, not PUT)
      const rolesData = { staff_id: id };
      Object.keys(roleLabels).forEach((key) => {
        rolesData[key] = staffData[key] || 0;
      });

      const roleRes = await fetch(`${BASE_URL}roles`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(rolesData),
      });
      const roleResult = await roleRes.json();

      if (roleResult.message?.toLowerCase().includes("success")) {
        alert("Staff and roles updated successfully!");
        navigate("/StaffList");
      } else {
        setError("Staff updated but failed to update roles.");
      }
    } catch (err) {
      console.error(err);
      setError("Error updating staff.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div id="main">
      <div className="page-heading">
        <h3>Edit Staff</h3>
      </div>

      <section className="section">
        <div className="card">
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={staffData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Number</label>
                <input
                  type="text"
                  name="number"
                  className="form-control"
                  value={staffData.number}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={staffData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  value={staffData.password}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Location</label>
                <select
                  name="inside_outside"
                  className="form-control"
                  value={staffData.inside_outside}
                  onChange={handleChange}
                >
                  <option value="inside">Inside</option>
                  <option value="outside">Outside</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Reference Name</label>
                <input
                  type="text"
                  name="reference_name"
                  className="form-control"
                  value={staffData.reference_name}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Reference Number / Salary</label>
                <input
                  type="text"
                  name="reference_number"
                  className="form-control"
                  value={staffData.reference_number}
                  onChange={handleChange}
                />
              </div>

              {/* Roles */}
              <div className="row">
                {Object.keys(roleLabels).map((key) => (
                  <div className="col-md-3 mb-2" key={key}>
                    <label>
                      <input
                        type="checkbox"
                        name={key}
                        checked={Number(staffData[key]) === 1}
                        onChange={handleChange}
                        className="form-check-input me-2"
                      />
                      {roleLabels[key]}
                    </label>
                  </div>
                ))}
              </div>

              <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Staff"}
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3 ms-2"
                onClick={() => navigate("/StaffList")}
              >
                Back
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditStaff;
